import React from "react";
import {
  BannerSection,
  LandingContainer,
  MainContainer,
  PlusContainer,
  PlusImgContainer,
  BackgroundImage
} from "./index.styled";
import GlobalStyle from "./globalStyles";
import { Helmet } from 'react-helmet';
import DotsBg from "../../assets/images/DotsBg.png";
import dashedVector from "../../assets/images/dashedVector.png";
import plusImg from "../../assets/images/plus.png";
import bluePlus from "../../assets/images/bluePlus.png";
import yellowPlus from "../../assets/images/yellowPlus.png";
import Usages from "../../components/usagesContainer";
import LandingHeader from "../../components/landingHeader";
import MainTitle from "../../components/landingMainHeader";
import Features from "../../components/FeaturesContainer";
import Companions from "../../components/CompanionsContainer";
import Contacts from "../../components/Contact-with-us";
import LandingFooter from "../../components/LandingFooter";
import headerBg from "../../assets/images/headerBg.svg";
import ChatBot from "../../components/danabot";

const Landing = () => {
  return (
    <>
      <Helmet>
        <title>آواشو</title>
      </Helmet>
      <GlobalStyle />
      <LandingContainer>

        <BackgroundImage>
          <img src={headerBg} />
        </BackgroundImage>

        <LandingHeader />

        <MainTitle/>

        <BannerSection>
          <div>
            <img src={DotsBg} alt="dot background" />
          </div>
          <div>
            <img src={dashedVector} alt="banner" />
            <img src={plusImg} alt="plus image" />
          </div>
        </BannerSection>

        <Usages />

        <PlusContainer>
          <PlusImgContainer>
            <div>
              <img src={bluePlus} alt="plusImage" />
            </div>
            <div>
              <img src={yellowPlus} alt="plusImage" />
            </div>
            <div>
              <img src={bluePlus} alt="plusImage" />
            </div>
          </PlusImgContainer>
        </PlusContainer>

        <Features/>

        <Companions/>

        <Contacts />

        <LandingFooter />
        {/* </MainContainer> */}
        <ChatBot />
      </LandingContainer>
    </>
  );
};

export default Landing;
